import { VolumetricGI } from "../../../../d3/component/Volume/VolumetricGI/VolumetricGI";
import { ReflectionProbe } from "../../../../d3/component/Volume/reflectionProbe/ReflectionProbe";
import { Bounds } from "../../../../d3/math/Bounds";
import { LayaGL } from "../../../../layagl/LayaGL";
import { Vector3 } from "../../../../maths/Vector3";
import { Vector4 } from "../../../../maths/Vector4";
export class WebVolumetricGI {
    constructor() {
        this._id = ++WebVolumetricGI._idCounter;
        this._probeCounts = new Vector3();
        this._probeStep = new Vector3();
        this._params = new Vector4();
        this._params = new Vector4();
        this.bound = new Bounds();
        this.shaderData = LayaGL.renderDeviceFactory.createShaderData();
    }
    setParams(value) {
        value.cloneTo(this._params);
    }
    setProbeCounts(value) {
        value.cloneTo(this._probeCounts);
    }
    setProbeStep(value) {
        value.cloneTo(this._probeStep);
    }
    applyRenderData() {
        let data = this.shaderData;
        data.addDefine(VolumetricGI.SHADERDEFINE_VOLUMETRICGI);
        data.setVector3(VolumetricGI.VOLUMETRICGI_PROBECOUNTS, this._probeCounts);
        data.setVector3(VolumetricGI.VOLUMETRICGI_PROBESTEPS, this._probeStep);
        data.setVector3(VolumetricGI.VOLUMETRICGI_PROBESTARTPOS, this.bound.getMin());
        data.setVector(VolumetricGI.VOLUMETRICGI_PROBEPARAMS, this._params);
        data._setInternalTexture(VolumetricGI.VOLUMETRICGI_IRRADIANCE, this.irradiance);
        data._setInternalTexture(VolumetricGI.VOLUMETRICGI_DISTANCE, this.distance);
        data.setNumber(ReflectionProbe.AMBIENTINTENSITY, this.intensity);
    }
    destroy() {
        this.shaderData.destroy();
        this.shaderData = null;
        this.irradiance = null;
        this.distance = null;
        this.bound = null;
    }
}
WebVolumetricGI._idCounter = 0;
